import React, { useState, useEffect } from 'react';
import styles from './notes.module.css';
import person_icon from '../../../images/icons/AuditTrailIcons/person_icon.svg';
import CommonBtn from '../../../containers/LeadProfile/CommonBtn/CommonBtn';
import NotesRow from './NotesRow';
const {} = styles;

const serverData = [
  {
    text: 'Priyanka commented on the case',
    id: '2123',
    name: 'Priya Mishra',
    date: 'Today 11:10 AM'
  },
  {
    text: 'Anil commented on the case',
    id: '2sdasd23',
    name: 'Ritu Chaudhary',
    date: '12 july 09:40 AM'
  },
  {
    text: 'Sunil commented on the case',
    id: '23223',
    name: 'Anita Sharma',
    date: '15 july 03:10 PM'
  },
  {
    text: 'Sudhir commented on the case',
    id: '2313',
    name: 'Ruchi Kumari',
    date: '17 july 02:30 PM'
  }
];
function AuditNotes({ isClosed }) {
  if (!isClosed) {
    return null;
  }

  const [notesData, setNotesData] = useState({
    isFetching: false,
    isFetched: false,
    isFaliure: false,
    data: serverData
  });

  function onDelete(index) {
    const newData = [...notesData.data];
    newData.splice(index, 1);
    setNotesData({ ...notesData, data: newData });
  }

  function updateNote(passText, index) {
    const updateData = [...notesData.data];
    const dataToUpdate = { ...updateData[index] };

    dataToUpdate.text = passText;

    // make API call

    updateData[index] = dataToUpdate;
    setNotesData({ ...notesData, data: updateData });
  }
  function addNewNotes(passText) {
    const addNewData = [...notesData.data];

    // make API call

    addNewData.unshift({
      id: Math.random(),
      name: 'Ruchi Kumari',
      date: '17 july 02:30 PM',
      text: passText
    });
    setNotesData({ ...notesData, data: addNewData });
  }
  const { data } = notesData;
  function onClickAction({ info }) {
    const { data } = info;
    if (data) {
      console.log('Is already there and we are editing');
    } else {
      console.log('Its a new creation');
    }
    console.log(info);
  }

  return (
    <React.Fragment>
      <div>
        <NotesRow
          isCreateMode
          onClickAction={onClickAction}
          addNewNotes={addNewNotes}
        />

        {data.map((each, index) => {
          return (
            <NotesRow
              index={index}
              key={each.id}
              data={each}
              onDelete={onDelete}
              updateNote={updateNote}
              onClickAction={onClickAction}
              setNotesData={setNotesData}
            />
          );
        })}
      </div>
    </React.Fragment>
  );
}

export default AuditNotes;
